import { useState } from "react";
import { useSelector } from "react-redux";

import CodeRounded from "@mui/icons-material/CodeRounded";
import { Box, IconButton, Tooltip } from "@mui/material";
import JsonPreview from "../common/JsonPreview";
import ResizeableSidebar from "../sidebar/ResizeableSidebar";

// Dev-only: shown only on a local/dev build so it never reaches a deployed
// portal. Covers `npm start` (NODE_ENV=development) and any localhost host.
const IS_DEV =
  process.env.NODE_ENV === "development" ||
  (typeof window !== "undefined" &&
    ["localhost", "127.0.0.1", "[::1]"].includes(window.location.hostname));

// The store holds large fetched loan payloads and the occasional non-serializable
// value (Dates, class instances). Guard against circular refs so the preview
// never throws on a malformed slice.

/**
 * ReduxStateDevButton — a `</>` icon button (dev/localhost only) that opens a
 * JSON preview of the entire Redux store. Top-level slices are pickable as chips
 * so the huge loan payloads don't drown the rest; "All" shows everything.
 */
const ReduxStateDevButton = ({ iconColor = "#ffffff" }) => {
  const [open, setOpen] = useState(false);
  const state = useSelector((state) => state);

  if (!IS_DEV) return null;

  return (
    <>
      <Tooltip title="Redux state (dev)" arrow>
        <IconButton
          onClick={() => setOpen(true)}
          size="small"
          sx={{ color: iconColor }}
        >
          <CodeRounded />
        </IconButton>
      </Tooltip>

      <ResizeableSidebar
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="lg"
        title="Redux State"
        // fullWidth
        // PaperProps={{ sx: { height: "85vh", borderRadius: "12px" } }}
      >
        <JsonPreview values={state} defaultCollapse={2} />
      </ResizeableSidebar>
    </>
  );
};

export default ReduxStateDevButton;
